<template>
  <div id='pageInvoice'>
    <div class='public-content pageInvoice_content'>
      <el-row class='buttonGroup'>
        <el-col :span='12'>
          <el-button v-for='item in buttonTab' :key='item.id' size="small" @click='hanleButtonTab(item)'
            :class='item.id === form.invoiceClassify ? "buttonActive" : ""' class='buttonList_s'>
            {{ item.name }}
          </el-button>

        </el-col>
        <!-- v-show="form.invoiceClassify!=3" -->
        <el-col :span='12' style='text-align: right;' >
          <!-- <el-button size="small" class='minButton' @click="handleDeleteData(ids)" v-for='i in deleteList' :key='i.id'>{{
            i.name }}</el-button>
          <el-button size="small" class='minButton' @click="voucherVisible = true">批量关联</el-button> -->

          <span v-for='item in rightButtonList' :key='item.id'>
            <!-- 批量操作 -->
            <span style="margin-left: 10px;" v-if='item.permission === "ac:invoice:batchoperation"'>
              <el-dropdown class="pageInvoice__dropdown">
                <el-button type="defaylt" split-button size='small'>
                  {{ item.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item  @click.native="batchOperation(i)" v-for='i in deleteList' :key='i.id'>
                    {{ i.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
            <!-- 批量凭证模板 -->
            <span style="margin-left: 10px;" v-if='item.permission === "ac:invoice:batchmodal"'>
              <el-dropdown class="pageInvoice__dropdown">
                <el-button type="defaylt" split-button size='small'>
                  {{ item.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-input v-model="searchVoucValue" placeholder="输入搜索内容" size="mini" style="width: 111px; margin: 5px"></el-input>
                  <el-dropdown-item v-for='i in voucherTemplateList_filter' :key='i.id' @click.native='handleSelectChangeAll(i)' style = 'width: 78px;'>
                    {{ i.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
            <!-- 导出按钮 -->
            <el-button size="small" class='minButton' @click='handleRightButtonListClick(item)'
              v-if='item.permission === "ac:invoice:export" && form.invoiceClassify!=3' style="margin-left: 10px;"
              >
              {{ item.name }}
            </el-button>
            <!-- 新增发票 -->
            <!-- <el-button size="small" class='minButton' @click='handleRightButtonListClick(item)'
              v-if='item.permission === "ac:invoice:save"'>
              {{ item.name }}
            </el-button> -->
            <!-- 自动生成凭证 -->
            <el-button size="small" class='minButton' @click='handleGenerate_before(item,3)'
              v-if='item.permission === "ac:preVoucherChief:show"' style="margin-left: 10px;"
              >
             自动生成
            </el-button>
            <!-- 生成凭证 -->
            <el-button size="small" class='minButton' @click='handleGenerate_before(item,1)'
              v-if='item.permission === "ac:preVoucherChief:show"' style="margin-left: 10px;"
              >
              {{ item.name }}
            </el-button>

            <!-- <el-dropdown v-else-if='item.permission === "ac:preVoucherChief:show"'
              >
              <el-button type="defaylt" split-button size='small' @click="handleGenerate_before(item)">
                  {{ item.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for='i in rightButtonList_child' :key='i.id' @click.native='handleChildrenClick(i)' style="width: 78px;">
                  {{ i.name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <!-- 取票 -->
            <el-dropdown v-else-if='item.permission === "ac:invoice:auto" && form.invoiceClassify!=3' style='margin: 0 10px;'>
              <el-button type="defaylt" split-button size='small' class='minButton'>
                {{ item.name }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for='i in rightButtonList_childs' :key='i.id'
                  @click.native='handleChildrenClick(i)'>
                  {{ i.name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </el-col>

      </el-row>
      <div class='filter_table' >
        <el-row>
          <el-col :span='12'>
            <div @click.stop='handleClickFilter'>
              <el-input size='small' readonly style="width:250px" v-model='inputText'>
                <template slot="append">
                  <i class='el-icon-search'></i>
                  筛选
                </template>
              </el-input>
            </div>
            <transition name="el-zoom-in-top">
              <div @click.stop='returnFalse' v-show='isFilterCardShow' class="filter_table_card">
                <el-card>
                  <el-row class='qijian'>
                    <span class='title'>期间</span>
                    <el-date-picker v-model="dateList" range-separator="至" type="daterange" size='small'
                      style="width:100%;margin-bottom: 30px;" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                      start-placeholder="开始月份" @change='getDataChange' :picker-options="pickerOptions" @clear = "inputText = ''"
                      end-placeholder="结束月份">
                    </el-date-picker>
                  </el-row>

                  <el-row class='qijian'>
                    <span class='title'>筛选</span>
                    <el-col :span='24' style="display: flex;align-items: center;margin-bottom:15px ">
                      <span style="margin-right: 10px;" color="c_6">发票种类</span>
                      <el-select v-model="invoiceTypeArr" style='flex:1' size='small' multiple collapse-tags clearable>
                        <el-option v-for="item in invoiceTypeList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span='24' style="display: flex;align-items: center;margin-bottom:15px " v-show="form.invoiceClassify==3">
                      <span style="margin-right: 10px;" color="c_6">发票类型</span>
                      <el-select v-model="newInvoiceClassify" style='flex:1' size='small' clearable >
                        <el-option v-for="item in invoiceClassifyList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span='24' style="display: flex;align-items: center;margin-bottom:15px ">
                      <span style="margin-right: 10px;" color="c_6">凭证状态</span>
                      <el-select v-model="form.haveVoucherChief" style='flex:1' size='small' clearable>
                        <el-option v-for="item in voucherStatusList" :key="item.id" :label="item.name"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span='24' style="display: flex;align-items: center;margin-bottom:15px;">
                      <span style="margin-right: 10px;" color="c_6">来源&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      <el-select v-model="form.invoiceSource" style='flex:1' size='small' clearable>
                        <el-option v-for="item in invoiceSourceList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span='24' style="display: flex;align-items: center;margin-bottom:15px ">
                      <span style="margin-right: 10px;" color="c_6">套用模板</span>
                      <el-select v-model="form.templateId" style='flex:1' size='small' clearable>
                        <el-option v-for="item in invoiceVoucherTemplateList" :key="item.id" :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                  <el-row style='text-align: center;margin-top: 15px;'>
                    <accBtn text = "清空" @click="handleRest('')" width="56px" type="2"></accBtn>
                    <accBtn text = "重置" @click="handleRest('reset')" width="56px" type="2"></accBtn>
                    <accBtn text = "搜索" @click="getPageInvoiceTableList('clearPage')" width="56px" type="1"></accBtn>
                    <!-- <el-button size='small' style='color: #268AFF;' @click='handleRest("")'>清空</el-button> -->
                    <!-- <el-button size='small' style='color: #268AFF;' @click='handleRest("reset")'>重置</el-button>
                    <el-button size='small' type='primary' @click="getPageInvoiceTableList('clearPage')">搜索</el-button> -->
                  </el-row>
                </el-card>
              </div>

            </transition>

          </el-col>
          <el-col :span='12' style='text-align: right;'>
            <el-input size='small' style='width: 280px;' v-model='form.content' placeholder='搜索发票号码/客户/供应商'
              @keyup.enter.native='getPageInvoiceTableList' clearable @clear='getPageInvoiceTableList'>
              <i slot="suffix" class="el-icon-search searchTableData" @click='getPageInvoiceTableList'></i>
            </el-input>
          </el-col>
        </el-row>

      </div>
      <!-- 表格 -->
      <public-table :table="tableData" @onHandlePaginationChange="handlePaginationChange" :style="{'margin-top':form.invoiceClassify==3?'20px':''}">
        <!-- 附件名称 -->
        <template slot="originalName" slot-scope="props">
          <span >{{props.scope.row.originalName}}</span>
          <!-- <el-input size="mini" v-model="props.scope.row.originalName" v-else @blur="nameChange(props.scope.row)"></el-input> -->
        </template>
        <!-- 上传时间-->
        <template slot="uploadTime" slot-scope="props">
          {{$formart(props.scope.row.uploadTime)}}
        </template>
        <!-- 附件缩略图-->
        <template slot="thumbnailPath" slot-scope="props">
          <img :src="`${imgShow}${props.scope.row.thumbnailPath}`" alt="" width="20px" height="20px" @click="openFileShow(props.scope.row.filePath)">
          <!-- <el-button type="text" @click="openFileShow(props.scope.row.thumbnailPath)">查看</el-button> -->
        </template>
        <template slot='invoiceType' slot-scope='props'>
          <span>{{ filterType(props.scope.row.invoiceType) }}</span>
        </template>
        <template slot='invoiceSource' slot-scope='props'>
          <span>{{ invoiceSourceObj[props.scope.row.invoiceSource] }}</span>
        </template>
        <template slot='vocherChiefWordNumber' slot-scope='props'>
          <el-button type='text' @click='handleWatchRow(props.scope.row)'>{{ props.scope.row.vocherChiefWordNumber
            }}</el-button>
        </template>
        <!-- 自动生成凭证模板 -->
        <template slot='predictedTemplateInfo' slot-scope='props'>
          <el-tooltip placement="right" v-if = "props.scope.row.predictedTemplateInfo && props.scope.row.predictedTemplateInfo.length > 0">
            <div slot="content">
              <div v-for="(item,index) in props.scope.row.predictedTemplateInfo" :key="index" class="mb10">
                {{  item.creditDirection }}：{{  item.subjectName }}
              </div>
            </div>
            <el-button type='text' >
              <i class="el-icon-view"></i>
            </el-button>
          </el-tooltip>
          <span v-else>-</span>
        </template>
        <!-- 附件来源 -->
        <template slot="source" slot-scope="props">
           <span>{{props.scope.row.source == 1?'用户上传':props.scope.row.source == 2?'小青蛙采集':''}}</span>
        </template>
        <!-- 发票明细 -->
        <template slot='invoiceItemsVoList' slot-scope='props'>
          <div v-if="props.scope.row.invoiceItemsVoList">
          <el-tooltip placement="right" v-if = "props.scope.row.invoiceItemsVoList.length > 0">
            <div slot="content" style="max-height: 300px;width:300px;overflow:auto;">
              <div v-for="(item,index) in props.scope.row.invoiceItemsVoList" :key="index" class="mb10" >
                {{  item.commodityName }}*{{  item.specificationModel }} &nbsp;
                <span v-show="item.quantity">
                  ×{{ item.quantity }}
                </span>
              </div>
            </div>
            <div class="textOver">{{ props.scope.row.invoiceItemsVoList[0].commodityName }}</div>
          </el-tooltip>
          <span v-else>-</span>
          </div>
        </template>
        <template slot='operation' slot-scope='props'>
          <el-button style='color:#268AFF;cursor: pointer;' @click='handleEditData(props.scope.row)'
            type='text'>{{ props.scope.row.vocherChiefWordNumber?"查看":"编辑" }}</el-button>
        </template>
        <template slot='invoiceVoucherTemplateId' slot-scope='props'>
          <el-select v-model="props.scope.row.invoiceVoucherTemplateId" placeholder="请选择" size='mini'
            style='width: 100%;' @change='handleSelectChange(props.scope.row)'
            :disabled='props.scope.row.vocherChiefWordNumber ? true : false'>
            <el-option v-for="item in voucherTemplateList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </template>
      </public-table>
    </div>

    <!-- 新增凭证 -->
    <new-add-page-invoice :newAddPageInvoiceShow.sync="newAddPageInvoiceShow" :nowEditRow='nowEditRow'
      :invoiceClassify='form.invoiceClassify' @successBack='successBack' :voucherTemplateList='voucherTemplateList'   @refreshTable='successEdit'
      @openTempelete='openTempelete' @openTask="openTempelete"></new-add-page-invoice>
    <!-- 生成凭证 -->
    <new-addvoucher-dialog :newAddVoucherDialogShow.sync='newAddVoucherDialogShow' :ids='generate_ids' :type="saveType"
      :voucherTemplateList='voucherTemplateList' :generateType="generateType" :settingType="settingType" :saveType="saveType"
      @refreshTable='refreshTable'>

    </new-addvoucher-dialog>
    <!-- 模板凭证弹框 -->
    <invoice-template :invoiceTemplateShow.sync='invoiceTemplateShow' @voucherTemplateLists='voucherTemplateLists'>
    </invoice-template>
    <!-- 修改凭证 -->
    <edit-voucher :visible="XG_voucherShow" :row="req_nowRow" @on-close-dialog="cancel($event, 'edit')"
      :voucherTitle="title"
      :hideBtn="true"
      @on-success-submit="successEdit" @refreshTable='successEdit' :openButton_s='openButton_s' v-if="XG_voucherShow">
    </edit-voucher>
    <!-- 导入 -->
    <add-invoice-import :AddInvoiceImportShow.sync='AddInvoiceImportShow' @successBack='successBack'
      :invoiceClassify='form.invoiceClassify'>

    </add-invoice-import>
    <!-- 关联凭证 -->
    <ConnectVoucher :visible="voucherVisible" @close="voucherVisible = false" :ids='ids' @success="successEdit" />
    <!-- 生成设置 -->
    <BuildSettings ref="buildSettings" @refresh="getSetting" />
    <!-- 导出提示 -->
    <ExportTip :showVisible.sync="exportVisible" :formData="exportTipData" @confirm="handleConfirmExport" />
    <!-- 生成凭证提示 -->
    <GenerateTip :showVisible.sync="generateVisible" :ListData = "selectDataList"  @confirm="gerGenIds" />
    <!-- 图片预览-->
    <previewPicture ref="previewPicture" :images="images"/>
  </div>
</template>
<script>
import { imgShow } from "@/assets/js/apiConfig.js";
import previewPicture from "@/components/previewPicture";
import { findInvoiceStatementHistory, findPermission,getAttachmentList,delAttachment} from '@/api'
import BuildSettings from '@/components/dialog/BuildSettings'
import editVoucher from '@/components/table/editVoucher'
import publicTable from '@/components/publicTable'
import newAddPageInvoice from '@/components/dialog/newAddPageInvoice'
import newAddvoucherDialog from '@/components/dialog/newAddVoucherDialog'
import invoiceTemplate from '@/components/dialog/invoiceTemplate'
import AddInvoiceImport from '@/components/dialog/AddInvoiceImport'
import { currencys } from '@/assets/utils/currencyFormat'
import { debounce } from '@/assets/utils/index'
import { invoiceSourceObj } from "@/assets/js/library"
import ConnectVoucher from "@/components/common/connect-voucher.vue"
import { invoiceTypes } from "@/assets/js/library"
import ExportTip from './exportTip.vue'
import { getFirstAndLastDayOfMonth } from "@/assets/utils"
import GenerateTip from "./generateTip.vue"
export default {
  components: {
    previewPicture,
    BuildSettings,
    publicTable,
    newAddPageInvoice,
    newAddvoucherDialog,
    editVoucher,
    invoiceTemplate,
    AddInvoiceImport,
    ConnectVoucher,
    ExportTip,
    GenerateTip
  },
  data() {
    return {
      imgShow,
      images:[],
      title:"查看凭证",
      saveType:1,
      searchVoucValue: "", // 筛选凭证模板
      exportTipData: {},
      settingType: '0',
      generateType: 0,
      generate_ids: "",
      exportVisible: false,
      accountInfoTime: {},
      invoiceFormKey: "invoiceSelect__" + sessionStorage.cid,
      invoiceSourceList: [
        { id: "-1", name: '全部来源' },
        { id: "2", name: '导入' },
        { id: "3", name: '手动新增' },
        { id: "5", name: 'crm同步' },
      ],
      invoiceSourceObj,
      voucherVisible: false,
      openButton_s: false,
      deleteList: [],    // 是否显示批量删除
      inputText: '',
      isFilterCardShow: false,  // 搜索
      invoiceVoucherTemplateList: [], // 发票模板
      invoiceTypeList: invoiceTypes,
      invoiceClassifyList:[
        { name:'销项',id:2},
        { name:'进项',id:1},
      ],
      voucherStatusList: [   // 凭证状态
        { name: "全部凭证", id: 3, value: "-1" },
        { name: "未生成凭证", id: 1, value: "2" },
        { name: "已生成凭证", id: 2, value: "1" },
      ],
      AddInvoiceImportShow: false,// 导入弹框
      invoiceTemplateShow: false,   // 模板凭证弹框
      req_nowRow: {},      // 当前点击凭证
      Voucher_Chief_Data: {},
      XG_voucherShow: false,
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            const now = new Date(); //当前时间
            const year = now.getFullYear(); //当前年份
            const start = new Date(`${year}, ${now.getMonth() + 1}, ${1}`); //当前月1号
            picker.$emit('pick', [start, now]);
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate: (time) => {
          let nowTime = new Date().getTime();
          return time.getTime() > nowTime
        }
      },
      AllidsNotemplete: [],
      allId: [],
      ids: "",
      allAttId:[],
      allIds:"",
      newAddVoucherDialogShow: false,   // 是否显示生成凭证弹出框
      generateVisible: false, // 是否显示生成凭证提示已生成弹框
      selectDataList:[],           // 当前选择的数据
      nowEditRow: {},// 当前编辑行
      voucherTemplateList: [],
      newAddPageInvoiceShow: false,  // 新增发票
      rightButtonList: [],      // 生成凭证，新增发票
      rightButtonList_child: [],  // 生成凭证下级
      rightButtonList_childs: [],  // 取票下级
      buttonTab: [          // 按钮切换
        { name: "销项发票", id: 2 },
        { name: "进项发票", id: 1 },
        { name: "附件列表",id:3},
      ],
      dateList: [],       // 时间区间
      invoiceTypeArr: ["-1"], // 发票种类多选
      form: {         // 筛选条件
        startTime: "",
        endTime: "",
        currentPage: "1",
        maxResult: "20",
        content: "",
        invoiceClassify: 2,
        invoiceType: "-1",
        haveVoucherChief: '2',   // 是否生成凭证
        invoiceSource: "-1", //来源
        templateId: "-1",
        fkBillId: "", // 发票的id，当这个参数有值优先筛选id
      },
      tableData: {
        border: true,				// 是否带有纵向边框
        stripe: true,				// 是否带有斑马纹
        loading: false,				// 是否显示加载动画
        hasSelect: true,			// 是否显示多选
        hasOperation: false,		// 是否有操作功能
        hasContextmenu: false,		// 是否有右键功能
        hasShowSummary: true,		// 是否显示合计行
        hasShowPagination: true,	// 是否显示分页
        // Maxheight: 600,			// Table最大高度
        config: [
          {
            label: '来源',
            value: 'invoiceSource',
            show: 'template'
          },
          {
            label: '开票日期',
            value: 'billingDate',
            show: 'normal'
          },
          {
            label: '发票号码',
            value: 'invoiceNumber',
            show: 'normal'
          }, {
            label: '客户/供应商名称',
            value: 'enterprieName',
            width: 150,
            show: 'normal'
          }, {
            label: '发票种类',
            value: 'invoiceType',
            show: 'template'
          }, {
            label: '发票明细',
            value: 'invoiceItemsVoList',
            showOverflowTooltip: false,
            show: 'template'
          },{
            label: '合计金额',
            value: 'totalAmount',
            show: 'normal',
            formatter: this.formatter
          }, {
            label: '税率',
            value: 'totalTaxRate',
            show: 'normal',
          }, {
            label: '合计税额',
            value: 'totalTax',
            show: 'normal',
            formatter: this.formatter
          }, {
            label: '价税合计',
            value: 'totalAmountAndTax',
            show: 'normal',
            formatter: this.formatter
          }, {
            label: '套用凭证模板',
            value: 'invoiceVoucherTemplateId',
            show: 'template',
            width: 120,
          },{
            label: '自动生成凭证模板',
            value: 'predictedTemplateInfo',
            show: 'template',
            width: 120,
          }, {
            label: '对应凭证',
            value: 'vocherChiefWordNumber',
            show: 'template',
          }, {
            label: '操作',
            value: 'operation',
            width: 130,
            show: 'template'
          }],
        data: [],
        page: {
          pageNo: 1,
          pageSize: 20,
          pageSizes: [10,20,30, 50, 100, 200 , 300 ,400],
          count: 10,
        },
        center: {
          textAlign: 'center',
          padding: '6px 0'
        },
        arraySpanMethod: this.arraySpanMethod,			// 自定义合并行
        getSummaries: this.getSummaries,			// 自定义合计方法
        toggleRowSelection: this.toggleRowSelection,		// 自定义全选方法
        selectable: this.selectable        // 自定义禁用
      },
      btnKey:{

      },
      newInvoiceClassify:"",
      spanMap: {} // 存储合并信息
    }
  },
  created() {
    this.handleAccountTime()
    let startTime = new Date(this.accountInfoTime.startTime);
    let endTime = new Date(this.accountInfoTime.endTime);
    this.dateList = [startTime, endTime]
    this.getButton();

    //this.getInvoiceVoucherTemplate();
    // 获取当前时间
  },
  mounted() {
      this.getPageInvoiceTableList();
  },
  computed: {
    voucherTemplateList_filter() {
      return this.voucherTemplateList.filter(i=> {
        return i.name.indexOf(this.searchVoucValue) !== -1
      })
    }
  },
  activated() {
    this.form.startTime = this.accountInfoTime.startTime;
    this.form.endTime = this.accountInfoTime.endTime;
    this.inputText = this.form.startTime + " 至 " + this.form.endTime;
    let startTime = new Date(this.accountInfoTime.startTime);
    let endTime = new Date(this.accountInfoTime.endTime);
    this.dateList = [startTime, endTime]
    // 判断路由有无参数
    this.form.fkBillId = "";
    const queryInfo = this.$route.query
    console.log('激活了')
    if (queryInfo.fkBillId) {
      this.form.fkBillId = queryInfo.fkBillId;
      console.log(queryInfo)
      this.form.invoiceClassify = Number(queryInfo.invoiceClassify)
      // 重置路由参数
      window.history.replaceState(null, null, 'pageInvoice')
      this.getPageInvoiceTableList()
      this.getHeader(queryInfo.invoiceClassify)
    }
    this.getSetting();

  },
  deactivated() {
    this.XG_voucherShow = false;
  },

  methods: {
    nameChange(row){
      console.log(row)
    },
    // 计算合并信息
    computeSpanMap() {
      this.spanMap = {};
      let currentId = null;
      // let currentId_2 = null;
      let startIndex = 0;

      this.tableData.data.forEach((item, index) => {
        if (item.attachmentId !== currentId) {
          currentId = item.attachmentId;
          // currentId_2 = item.id;
          startIndex = index;
          let count = 1;
          // 计算连续相同ID的数量
          for (let j = index + 1; j < this.tableData.data.length; j++) {
            if (this.tableData.data[j].attachmentId === currentId ) {
              count++;
            } else {
              break;
            }
          }
          this.spanMap[currentId] = { start: startIndex, count };
          // this.spanMap[currentId_2] = { start: startIndex, count };
        }
      });
    },
    // 合并
		arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if(this.form.invoiceClassify==3){
      if ([10,11,12,13].indexOf(columnIndex)>-1) {
        const id = row.attachmentId;
        const info = this.spanMap[id];
          if(info){
            if (rowIndex === info.start) {
              return { rowspan: info.count, colspan: 1 };
            } else {
              return { rowspan: 0, colspan: 0 };
            }
          }
        }
        // if(columnIndex <10 && columnIndex > 0){
        // const id = row.id;
        // const info = this.spanMap[id];
        //   if(info){
        //     if (rowIndex === info.start) {
        //       return { rowspan: info.count, colspan: 1 };
        //     } else {
        //       return { rowspan: 0, colspan: 0 };
        //     }
        //   }
        // }
      }
			// if (columnIndex < 9 || columnIndex > 12) {
			// 	if (row.rows) {
			// 		return {
			// 			rowspan: row.rows,
			// 			colspan: 1
			// 		}
			// 	} else {
			// 		return {
			// 			rowspan: 0,
			// 			colspan: 0
			// 		}
			// 	}
			// }
		},
    openFileShow(row){
      this.images = [`${this.imgShow}${row}`]
      this.$refs.previewPicture.show()
    },
    //查询附件列表
    getFileList(){
      this.tableData.loading = true
      let params = {
        currentPage:this.form.currentPage,
        maxResult:this.form.maxResult
      }
      params = Object.assign(params,this.form)
      delete params.invoiceSource
      delete params.fkBillId
      params.invoiceClassify = this.newInvoiceClassify
      // console.log()
      getAttachmentList(params).then(res=>{
        if(res.data.code == 1){
          console.log(res.data.data)
          this.tableData.data = res.data.data.list.map(x=>{
            x.isEdit = false
            return x
          })
          this.tableData.page.count = parseInt(res.data.data.totalCount);
          this.computeSpanMap()
        }
      }).finally(()=>{
        this.tableData.loading = false
      })
    },
    // 批量操作
    batchOperation(i) {
      if (i.permission === "ac:invoice:delete") {   // 批量删除
       this.handleDeleteData(this.ids)
      } else if (i.permission === "ac:invoice:related") {  // 批量关联
        this.voucherVisible = true
      } else  if (i.permission === "ac:invoiceVouTem:show") {   // 凭证模板
        this.invoiceTemplateShow = true;
      } else if (['ac:preVoucherChief:show'].indexOf(i.permission) > -1) { // 生成凭证

      } else if (i.permission === "ac:invoice:import") {
        this.handleImportShow();
      } else if (i.permission === "ac:preVoucherChief:setting") {
        this.$refs.buildSettings.openTask('invoice_key', this.settingType)
      }
    },
    // 获取本页面所有按钮权限
    async findAllPermission() {

    },
    // 获取需要生成的ids
    gerGenIds(genList) {
      let generate_idsArr = genList.map(i=> i.id)
      this.generate_ids = generate_idsArr.toString();
      this.newAddVoucherDialogShow = true;
    },
    setColSpan() {
      setTimeout(function () {
        if (document.querySelector("#pageInvoice")) {
          var current = document
            .querySelector("#pageInvoice")
            .querySelector(".el-table__footer-wrapper")
            .querySelector(".el-table__footer");
          var cell = current.rows[0].cells;

          cell[0].colSpan = "6";
          cell[11].colSpan = "4"
          for(let i=1;i<6;i++) {
            cell[i].style.display = "none";
          }
          for(let i=12;i<15;i++) {
            cell[i].style.display = "none";
          }
        }
      }, 50);
    },
    // 自定义合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (this.form.invoiceClassify == 3?index === 6 || index === 8|| index === 9:index === 7||index ===9||index===10) {
          const values = data.map(item => {
            return Number(item[column.property])
          });

          if (!values.every(value => { isNaN(value) })) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                prev = Number(prev)
                if (!(parseFloat(prev) + parseFloat(curr))) {
                  return '';
                } else {
                  return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                }
              } else {
                return parseFloat(prev).toFixed(2);
              }
            }, 0);
          } else {
            sums[index] = '';
          }

        }else if (this.form.invoiceClassify == 3?index === 7:index === 8) {
          sums[index] = '-';
        }else {
          return
        }

      });
      if (sums) {
        return sums;
      } else {
        return '';
      }
    },
    // 处理账套时间
    handleAccountTime() {
      let accountInfo = this.$getSessionStorage('accountInfo')
      let accountTime = getFirstAndLastDayOfMonth(accountInfo.yearPeriodTimeStamp);
      // 如果尾部时间比当前时间更大，则最多到当前时间
      if (new Date(accountTime.lastDay).getTime() > new Date().getTime()) {
        accountTime.lastDay = this.$util.formatDate.format(new Date().getTime(), 'yyyy-MM-dd')
      }
      this.accountInfoTime = {
        startTime: accountTime.firstDay,
        endTime: accountTime.lastDay
      }
    },
    handleClickFilter() {
      this.isFilterCardShow = !this.isFilterCardShow
    },
    //获取生成设置
    getSetting() {
      findInvoiceStatementHistory({ key: 'invoice_key' }).then(res => {
        if (res.data.code == 1) {
          this.settingType = res.data.data
        }
      })
    },
    filterType(type) {
      // const type =
      let str = ''
      this.invoiceTypeList.forEach(e => {
        if (e.id == type) {
          str = e.label
        }
      })
      return str
    },
    // yesTest:debounce(function(val){
    // 	console.log(this)
    // 	console.log(val)
    // },300),
    formatter(row, column, cellValue, index) {
      return currencys(cellValue)
    },
    // 打开模板凭证
    openTempelete(data) {
      this.invoiceTemplateShow = true;
    },
    // 阻止默认
    returnFalse() {
      return false;
    },
    // 重置
    handleRest(status) {
      this.form.fkBillId = ""
      this.newInvoiceClassify = ''
      if (!status) {
        // 清空
        this.form = Object.assign(this.form, {
          invoiceType: "",
          haveVoucherChief: '',   // 是否生成凭证
          templateId: "",
          invoiceSource: "",
          startTime: "",
          endTime: "",
        })
        this.invoiceTypeArr = [];
        this.dateList = []
        this.inputText = ""
        return
      }
      this.newInvoiceClassify = ''
      this.form = Object.assign(this.form, {
        invoiceType: "-1",
        haveVoucherChief: '2',   // 是否生成凭证
        templateId: "-1",
        invoiceSource: "-1",

      })
      this.invoiceTypeArr = ['-1'];
      let currentDate = new Date(this.accountInfoTime.endTime);
      let pastDate = new Date(this.accountInfoTime.startTime);
      this.dateList = [pastDate, currentDate]
      this.form.startTime = this.accountInfoTime.startTime;
      this.form.endTime = this.accountInfoTime.endTime;
      this.inputText = this.form.startTime + " 至 " + this.form.endTime;
      this.isFilterCardShow = false;
      this.getPageInvoiceTableList(true);
    },
    // 查询凭证模板
    // getInvoiceVoucherTemplate() {
    // 	this.$http.post('InvoiceVoucherTemplateController/getAllTemplate' , {}).then(res=>{
    // 		if(res&&res.data.code==1){
    // 			this.invoiceVoucherTemplateList = res.data.data;
    // 			this.invoiceVoucherTemplateList.unshift({
    // 				name:"未套用模板",
    // 				id:0
    // 			});
    // 		}
    // 	})
    // },
    // 导入弹框打开
    handleImportShow() {
      this.AddInvoiceImportShow = true;
    },
    // 修改成功回调
    successEdit(data) {
      this.getPageInvoiceTableList();
    },
    // 修改关闭
    cancel(e, type) {
      this.XG_voucherShow = false;
      this.openButton_s = false;
    },
    // 点击对应凭证
    handleWatchRow(row) {
      this.XG_voucherShow = true;
      this.openButton_s = true;
      let data = JSON.parse(JSON.stringify(row))
      data.id = data.voucherChiefId;
      this.req_nowRow = data;
    },
    // 自定义禁用
    selectable(row, index) {
      if(row.attachmentId){
        return true
      }
      if(!row.id || row.voucherChiefId){
        return false
      }else {
        return true
      }
      // if (row.vocherChiefWordNumber) {
      //   return false;
      // } else {
      //   return true;
      // }
    },
    // 刷新表格
    refreshTable(data) {
      if (data) {
        this.getPageInvoiceTableList();
      }
    },
    handleGenerate_before(item,type) {
      if (this.AllidsNotemplete.length !== this.allId.length && type !== 3) {
          return this.$message.warning("检测到列表有选项未设置模板凭证，请将发票设置相应的凭证模板后再生成凭证！")
        }
        if (!this.ids) {
          return this.$message.warning("请至少选择一张发票生成凭证！")
        }
        //单个生成1,多个生成2
        this.saveType = type
        this.generateType = this.settingType == '0' ? 1 : 2
        let isAllGen = this.selectDataList.every(i=> i.vocherChiefWordNumber);
        if (isAllGen) {
          return this.$message.warning('请选择未生成凭证的数据！')
        }
        // 检查是否选择了已生成凭证的数据
        let genList = this.selectDataList.filter(i=> i.vocherChiefWordNumber);
        if(genList.length > 0) {
          // 有生成的凭证
          this.generateVisible = true
        }else {
          let generate_idsArr = this.selectDataList.map(i => i.id);
          this.generate_ids = generate_idsArr.toString();
          this.newAddVoucherDialogShow = true;
        }
    },
    // 生成凭证点击
    handleChildrenClick(i) {
      if (i.permission === "ac:invoiceVouTem:show") {   // 凭证模板
        this.invoiceTemplateShow = true;
      } else if (['ac:preVoucherChief:show'].indexOf(i.permission) > -1) { // 生成凭证

      } else if (i.permission === "ac:invoice:import") {
        this.handleImportShow();
      } else if (i.permission === "ac:preVoucherChief:setting") {
        this.$refs.buildSettings.openTask('invoice_key', this.settingType)
      }else {
        this.handleRightButtonListClick(i)
      }
    },
    // 编辑表格行数据
    handleEditData(row) {
      // if (row && row.vocherChiefWordNumber) {
      //   return this.$message.warning('当前发票已经生成凭证，请删除凭证后再尝试!')
      // }
      this.nowEditRow = row;
      this.newAddPageInvoiceShow = true;
    },
    // 批量模板凭证改变
    handleSelectChangeAll(value) {
      if (!this.ids) {
        return this.$message.warning("请至少选择一条数据！")
      }
      this.handleSelectChange({ id: this.ids, invoiceVoucherTemplateId: value.id });
    },
    // 模板凭证改变
    handleSelectChange(row) {
      this.$http.post('invoiceController/updTemId', { invoiceIds: row.id, temId: row.invoiceVoucherTemplateId }).then(res => {
        if (res && res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.getPageInvoiceTableList();
        }
      })
    },
    // 模板凭证
    voucherTemplateLists(data) {
      this.voucherTemplateList = JSON.parse(JSON.stringify(data));
      this.invoiceVoucherTemplateList = JSON.parse(JSON.stringify(data));
      this.invoiceVoucherTemplateList.unshift({
        name: "未套用模板",
        id: "0"
      });
      this.invoiceVoucherTemplateList.unshift({
        name: "全部模板",
        id: "-1"
      });
    },
    // 发票新增保存返回
    successBack(data) {
      if (data) {
        this.getPageInvoiceTableList();
      }
    },
    // 确认导出
    handleConfirmExport(ids) {
      let addParams = {}
      if (ids) {
        addParams = { fkBillId: ids }
      }else {
        addParams = {
          ...this.form
        }
      }
      const params = {
        cid: sessionStorage.cid,
        token: sessionStorage.token,
        ...addParams
      }
      const router = this.$router.resolve({
        path: '/export/exportInvoice',
        query: params
      })
      window.open(this.$rootUrl + router.href, '_blank');
      let voucherChiefLabelObj = this.voucherStatusList.filter(item => item.value === this.form.haveVoucherChief)[0];
      this.$message.success(`"${voucherChiefLabelObj.name}" 导出成功`)
      this.exportVisible = false;
    },
    // 右边按钮组点击功能
    handleRightButtonListClick(i) {
      if (i.name === "新增发票") {
        this.newAddPageInvoiceShow = true;
        this.nowEditRow = {};
      } else if (i.permission === "ac:invoice:export") {
        if(this.ids) {
          this.handleConfirmExport(this.ids)
          return
        }
        // 判断是否为空
        if (this.checkForm()) {
          return this.$message.error('可选“日期、发票种类、凭证状态、来源、套用模版”任意条件导出。')
        }
        const names = this.invoiceTypeArr.reduce((accumulator, currentId) => {
          const found = this.invoiceTypeList.find(item => item.id === currentId);
          if (found) {
            if (accumulator) {
              accumulator += ', ';
            }
            accumulator += found.label;
          }
          return accumulator;
        }, ''); // 初始累积器为空字符串
        let voucherChiefLabelObj = this.voucherStatusList.filter(item => item.value === this.form.haveVoucherChief)[0];
        let sourceLabelObj = this.invoiceSourceList.filter(item => item.id === this.form.invoiceSource)[0];
        let templateLabelObj = this.invoiceVoucherTemplateList.filter(item => item.id === this.form.templateId)[0];

        // 准备提示数据
        this.exportTipData = {
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          invoiceLabel: names,
          voucherChiefLabel: voucherChiefLabelObj ? voucherChiefLabelObj.name : '',
          sourceLabel: sourceLabelObj ? sourceLabelObj.name : '',
          templateLabel: templateLabelObj ? templateLabelObj.name : '',
        }
        this.exportVisible = true;
      }
    },
    // 验证筛选参数是否全是为空
    checkForm() {
      this.form.invoiceType = this.invoiceTypeArr.toString();
      let checkData = [
        this.form.startTime,
        this.form.endTime,
        this.form.invoiceType,
        this.form.haveVoucherChief,
        this.form.invoiceSource,
        this.form.templateId,
      ]
      return checkData.every(i => {
        return i === '' || i === null || i === undefined
      })
    },
    // 全选
    toggleRowSelection(val) {
      let ids = val.map(i => { return i.id });
      let attIds = val.map(i => { return i.attachmentId });
      let idsNotemplete = val.map(i => { return i.id && i.invoiceVoucherTemplateId });
      this.allId = ids;
      this.allAttId = attIds;
      this.AllidsNotemplete = idsNotemplete.filter(i => {
        return i;
      });
      this.allIds = attIds.toString();
      this.ids = ids.toString();
      this.selectDataList = val;
    },
    // 删除表格数据
    handleDeleteData(ids, row) {
      if (row && row.vocherChiefWordNumber) {
        return this.$message.warning('当前发票已经生成凭证，请删除凭证后再尝试!')
      }
      if (!ids && this.form.invoiceClassify !=3) {
        return this.$message.warning("请先选择删除的数据！")
      }
      this.$confirm('是否删除数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(this.form.invoiceClassify == 3){
          delAttachment({ ids: this.allIds }).then(res => {
          if (res && res.data.code == 1) {
            if(res.data.msg == 'success'){
              this.$message.success('删除成功')
            }else {
              this.$message.error('已生成凭证，删除失败')
            }
            this.getPageInvoiceTableList();
            this.allIds = "";
          }
        })
          return false
        }
        this.$http.post('invoiceController/delInvoices', { ids: ids }).then(res => {
          if (res && res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.getPageInvoiceTableList();
            this.ids = "";
          }
        })
      }).catch(() => {

      });

    },
    getHeader(id){
      if(id == 3) {
          this.tableData.config = [
          {
            label: '开票日期',
            value: 'billingDate',
            show: 'normal'
          },
          {
            label: '发票号码',
            value: 'invoiceNumber',
            show: 'normal'
          }, {
            label: '客户/供应商名称',
            value: 'enterprieName',
            width: 150,
            show: 'normal'
          }, {
            label: '发票种类',
            value: 'invoiceType',
            show: 'template'
          }, {
            label: '发票明细',
            value: 'invoiceItemsVoList',
            showOverflowTooltip: false,
            show: 'template'
          },{
            label: '合计金额',
            value: 'totalAmount',
            show: 'normal',
            formatter: this.formatter
          }, {
            label: '税率',
            value: 'totalTaxRate',
            show: 'normal',
          }, {
            label: '合计税额',
            value: 'totalTax',
            show: 'normal',
            formatter: this.formatter
          }, {
            label: '价税合计',
            value: 'totalAmountAndTax',
            show: 'normal',
            formatter: this.formatter
          }, {
            label:'附件名称',
            value:'originalName',
            show:'template',
          },
          {
            label:"附件缩略图",
            value:'thumbnailPath',
            show:'template'
          },
          {
            label:'上传时间',
            value:'uploadTime',
            show:'template'
          },
          {
            label:'附件来源',
            value:'source',
            show:'template'
          },
          {
            label: '套用凭证模板',
            value: 'invoiceVoucherTemplateId',
            show: 'template',
            width: 120,
          },{
            label: '自动生成凭证模板',
            value: 'predictedTemplateInfo',
            show: 'template',
            width: 120,
          }, {
            label: '对应凭证',
            value: 'vocherChiefWordNumber',
            show: 'template',
          }, {
            label: '操作',
            value: 'operation',
            width: 130,
            show: 'template'
          }]
      }else {
         this.tableData.config = [
          {
            label: '来源',
            value: 'invoiceSource',
            show: 'template'
          },
          {
            label: '开票日期',
            value: 'billingDate',
            show: 'normal'
          },
          {
            label: '发票号码',
            value: 'invoiceNumber',
            show: 'normal'
          }, {
            label: '客户/供应商名称',
            value: 'enterprieName',
            width: 150,
            show: 'normal'
          }, {
            label: '发票种类',
            value: 'invoiceType',
            show: 'template'
          }, {
            label: '发票明细',
            value: 'invoiceItemsVoList',
            showOverflowTooltip: false,
            show: 'template'
          },{
            label: '合计金额',
            value: 'totalAmount',
            show: 'normal',
            formatter: this.formatter
          }, {
            label: '税率',
            value: 'totalTaxRate',
            show: 'normal',
          }, {
            label: '合计税额',
            value: 'totalTax',
            show: 'normal',
            formatter: this.formatter
          }, {
            label: '价税合计',
            value: 'totalAmountAndTax',
            show: 'normal',
            formatter: this.formatter
          },
          {
            label: '套用凭证模板',
            value: 'invoiceVoucherTemplateId',
            show: 'template',
            width: 120,
          },{
            label: '自动生成凭证模板',
            value: 'predictedTemplateInfo',
            show: 'template',
            width: 120,
          }, {
            label: '对应凭证',
            value: 'vocherChiefWordNumber',
            show: 'template',
          }, {
            label: '操作',
            value: 'operation',
            width: 130,
            show: 'template'
          }]
      }
    },
    // 按钮切换点击
    hanleButtonTab(i) {
      this.form.invoiceClassify = i.id;
      this.form.fkBillId = '';
      this.getHeader(i.id)
      if(i.id == 3) {
        this.getFileList()
        return
      }
      this.getPageInvoiceTableList();
    },
    // 翻页
    handlePaginationChange(data) {
      const { pageNo, pageSize } = data;
      if (pageNo) {
        this.$set(this.form, 'currentPage', pageNo);
        this.$set(this.tableData.page, 'pageNo', pageNo);
      }

      if (pageSize) {
        this.$set(this.form, 'maxResult', pageSize);
        this.$set(this.tableData.page, 'pageSize', pageSize);
      }
      if(this.form.invoiceClassify == 3){
        this.getFileList()
        return
      }
      this.getPageInvoiceTableList();
    },
    // 会计期间改变事件
    getDataChange(val) {
      if (!val) {
        this.form.startTime = ''
        this.form.endTime = ''
        this.inputText = ''
        this.dateList = []
        return
      }
      this.form.startTime = val[0];
      this.form.endTime = val[1];
      this.inputText = this.form.startTime + " 至 " + this.form.endTime;
      //this.getPageInvoiceTableList();
    },
    // 发票列表查询
    getPageInvoiceTableList(clearPage) {
      // 需要判断参数是否所有都为空
      if (this.checkForm()) {
        return this.$message.error('可选“日期、发票种类、凭证状态、来源、套用模版”任意条件查询。')
      }
      this.isFilterCardShow = false;
      this.tableData.loading = true;
      this.form.invoiceType = this.invoiceTypeArr.toString();
      if (clearPage) {
        this.form.currentPage = 0;
        localStorage.setItem(this.invoiceFormKey, this.form.invoiceType);
      } else {
        let invoiceTypeArrStr = localStorage.getItem(this.invoiceFormKey)
        if (invoiceTypeArrStr) {
          this.invoiceTypeArr = invoiceTypeArrStr.split(',')
        }
      }
      if(this.form.invoiceClassify == 3){
        this.getFileList()
        return
      }
      this.$http.post('invoiceController/invoiceList', this.form).then(res => {
        this.tableData.loading = false;
        if (res && res.data.code == 1) {
          this.tableData.page.count = parseInt(res.data.data.totalCount);
          let tableDatas = res.data.data.list.map(i => {
            i.totalTaxRate = (i.totalTaxRate * 100).toFixed(0) + "%";
            // let invoiceItemsVoList = i.invoiceItemsVoList
            // const jsonData = i.predictedInvoiceVoucherSubjectDetails.replace(/\b(\d+)\b/g, '"$1"');
            // const parsedArray = JSON.parse(jsonData);
            // console.log(parsedArray,'predictedInvoiceVoucherSubjectDetails');

            return i;
          });
          this.tableData.data = tableDatas;
          this.setColSpan()
        }
      })
    },
    // 获取按钮权限
    getButton(type) {
      let params = {
        permissions: 'ac:invoice:export,ac:preVoucherChief:show,ac:invoice:auto,ac:invoice:batchoperation,ac:invoice:batchmodal,ac:autoPreVoucherChief:show' // 获取主要按钮
      }
      let params_child = {
        // permissions:'ac:preVoucherChief:singleSave,ac:preVoucherChief:save,ac:invoiceVouTem:show' // 获取生成凭证按钮  舍弃分开生成和合并生成
        permissions: 'ac:invoiceVouTem:show,ac:preVoucherChief:setting,ac:invoice:delete,ac:invoice:related' // 获取生成凭证按钮 增加生成设置
      }
      let params_childs = {
        permissions: 'ac:invoice:save,ac:invoice:import' // 获取取票下级
      }
      // let params_delete = {
      //   permissions: 'ac:invoice:delete,ac:invoice:related' // 批量删除
      // }
      // 主要按钮
      try {
        this.$http.post('sys/menu/findPermissionMenu', params).then(res => {
          if (res.data && res.data.code == 1) {
            this.rightButtonList = res.data.data;
          }
        })
      } catch (e) {

      }
      //  生成凭证下级按钮
      try {
        this.$http.post('sys/menu/findPermissionMenu', params_child).then(res => {
          if (res.data && res.data.code == 1) {
            this.deleteList = res.data.data
            // this.rightButtonList_child = res.data.data;
          }
        })
      } catch (e) {

      }
      //取票下级
      try {
        this.$http.post('sys/menu/findPermissionMenu', params_childs).then(res => {
          if (res.data && res.data.code == 1) {
            this.rightButtonList_childs = res.data.data;
          }
        })
      } catch (e) {

      }
      // // 批量删除
      // try {
      //   this.$http.post('sys/menu/findPermissionMenu', params_delete).then(res => {

      //     if (res.data && res.data.code == 1) {
      //       this.deleteList = [...this.deleteList,...res.data.data]
      //       // this.deleteList = res.data.data;
      //     }
      //   })
      // } catch (e) {

      // }
    },
    clickBodys() {
      this.isFilterCardShow = false;
    }
  },
  watch: {
    isFilterCardShow(val) {
      val ? document.body.addEventListener('click', this.clickBodys) : document.body.removeEventListener('click', this.clickBodys)
    }
  }
}
</script>
<style lang='less'>
.el-button--text {
    color: #51b195 !important;
  }
#pageInvoice {
  height: 100%;
  .pageInvoice_content {
    box-sizing: border-box;
  }
  .buttonActive {
    background: #269D7B;
    color: #fff;
    border-color: #269D7B;
  }

  .buttonList_s {
    font-weight: 600;
    font-size: 14px;
    border-radius: 4px 0 0 4px;
    &:hover {
      color: #269D7B;
      border-color: #74dabd;
      background-color: #e7fdf7;
    }
    &:nth-child(2){
      margin-left: 0;
      border-radius: 0;
    }
    &:last-child {
      margin-left: 0;
      border-radius: 0 4px 4px 0;
    }

    ;
  }

  .filter_table {
    padding: 20px 0;
    position: relative;

    .el-input-group__append {
      padding: 0 10px;
      background-color: #269D7B;
      color: #fff;
      border-color: #269D7B;
      cursor: pointer;
    }

    .el-input__suffix {
      cursor: pointer;
      line-height: 32px;
      padding-right: 10px;
      right: 0;

      &:active {
        transform: scale(1.2);
      }

      ;

      .searchTableData {
        font-size: 16px;
      }

    }

    .filter_table_card {
      width: 300px;
      position: absolute;
      z-index: 99;
      .qijian {
        .title {
          font-weight: 600;
          color: #333;
          display: block;
          width: 100%;
          margin-bottom: 15px;
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pageInvoice/pageInvoice.vue